























































































import { Simulation, SimulationDetail } from "@/api/custom-simulation";
import { safeJsonParse } from "@/utils/safe-json-parse";
import moment from "moment";
import Vue from "vue";
import Ellipsis from "@/components/Ellipsis.vue";
import { SimulationType, SimulationTypeText } from "@/constants/custom-simulation";

type HomePageData = {
    courseIntroduction?: string;
    taskRequirements?: string;
    filePath?: string;
};
export default Vue.extend({
    data() {
        return { defaultCover: require("@/assets/product_thumbnail.png") };
    },
    methods: {
        formatTime(val) {
            return moment(val).format("YYYY.MM.DD");
        },
        async enterSimulation() {
            const sort = this.isFinished
                ? this.currentSimulation.step + 1
                : this.currentSimulation.step + 2;
            this.$store.commit(
                "customSimulationModule/setSelectedSimulationDetail",
                this.$store.state.customSimulationModule.currentSimulationDetail.find(
                    v => v.sort === sort
                )
            );
            await this.$store.dispatch("customSimulationModule/getSimulationResrouceDetail", {
                designFileId: this.$store.state.customSimulationModule.currentSimulationDetail.find(
                    v => v.sort === sort
                ).designFileId
            });
            this.$router.push("/simulationModelPage");
        }
    },
    computed: {
        nextTitle(): string {
            const nextClassType = this.currentSimulationDetail.find(
                v => v.sort === this.currentSimulation.step + 2
            )?.classType;
            if (nextClassType) {
                return `下一个课时：${SimulationTypeText[nextClassType]}`;
            }
            return "";
        },
        currentSimulationDetail(): SimulationDetail[] {
            return this.$store.state.customSimulationModule.currentSimulationDetail;
        },
        simulationDetailCount(): number {
            return this.$store.state.customSimulationModule.currentSimulationDetail.filter(
                v => ![SimulationType.homePage, SimulationType.loadingPage].includes(v.classType)
            ).length;
        },
        currentSimulation(): Simulation {
            return this.$store.state.customSimulationModule.currentSimulation;
        },
        simulationHomePage(): SimulationDetail {
            return this.$store.getters["customSimulationModule/simulationHomePage"];
        },
        homePageData(): HomePageData {
            return safeJsonParse(this.simulationHomePage.viewSettings);
        },
        isVideo(): boolean {
            if (this.homePageData.filePath) {
                const index = this.homePageData.filePath.lastIndexOf("%2E") + 3;
                return this.homePageData.filePath.slice(index) === "mp4";
            }
            return false;
        },
        isFinished(): boolean {
            return this.currentSimulation.step === this.simulationDetailCount;
        }
    },
    components: { Ellipsis }
});
